<div
  *ngIf="!!lineItem.price && !!lineItem.currency; else noPrice"
  [class.reserved]="!lineItem.sold && !!lineItem.reserved"
  [class.sold]="!!lineItem.sold"
  class="text-center"
>
  <span *ngIf="lineItem.sold" class="badge rounded-pill bg-danger border border-light sold-badge">
    <ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper">
      <ng-container *ngIf="lineItem.soldTo === null; else soldToSomeone" [ngTemplateOutlet]="sold"> </ng-container>

      <ng-template #soldToSomeone>
        <ng-container *ngIf="currentUserWrapper.user; else sold">
          <ng-container [ngSwitch]="currentUserWrapper.user.id">
            <ng-container *ngSwitchCase="lineItem.soldTo">
              {{ "Sold to you" | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="lineItem.user">
              <ng-container *ngIf="soldToUser; else sold">
                {{ "Sold to {{0}}" | translate: { "0": soldToUser.displayName } }}
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #sold>
        {{ "Sold" | translate }}
      </ng-template>
    </ng-container>
  </span>

  <span
    *ngIf="!lineItem.sold && lineItem.reserved"
    class="badge rounded-pill bg-warning border border-light reserved-badge"
  >
    <ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper">
      <ng-container [ngSwitch]="currentUserWrapper.user?.id">
        <ng-container *ngSwitchCase="lineItem.reservedTo">
          {{ "Reserved to you" | translate }}
        </ng-container>
        <ng-container *ngSwitchCase="lineItem.user">
          <ng-container *ngIf="reservedToUser; else reserved">
            {{ "Reserved to {{0}}" | translate: { "0": reservedToUser.displayName } }}
          </ng-container>
          <ng-template #reserved>
            {{ "Reserved" | translate }}
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ "Reserved" | translate }}
        </ng-container>
      </ng-container>
    </ng-container>
  </span>

  <div class="price">
    {{ lineItem.price | currency: lineItem.currency : "symbol" : "1.2-2" : translateService.currentLang }}
  </div>

  <div class="shipping-cost">
    <ng-container *ngIf="lineItem.shippingCostType === MarketplaceShippingCostType.NO_SHIPPING">
      <!-- leave it empty -->
    </ng-container>

    <ng-container *ngIf="lineItem.shippingCostType === MarketplaceShippingCostType.COVERED_BY_SELLER">
      {{ "Seller pays for shipping" | translate }}
    </ng-container>

    <ng-container *ngIf="lineItem.shippingCostType === MarketplaceShippingCostType.FIXED">
      <ng-container *ngIf="!!lineItem.shippingCost; else freeShippingTemplate">
        {{ "+ shipping" | translate }}:
        {{ lineItem.shippingCost | currency: lineItem.currency : "symbol" : "1.2-2" : translateService.currentLang }}
      </ng-container>
      <ng-template #freeShippingTemplate>
        {{ "Free Shipping" | translate }}
      </ng-template>
    </ng-container>

    <ng-container *ngIf="lineItem.shippingCostType === MarketplaceShippingCostType.TO_BE_AGREED">
      {{ "Shipping cost to be agreed" | translate }}
    </ng-container>
  </div>
</div>

<ng-template #noPrice>
  <div class="price">
    {{ "0.-" | translate }}
  </div>
</ng-template>
